<template>
    <div class="profile-wrapper">
        <div class="profile">
            <ul>
                <li>
                    <span>Email: </span><span>{{ userInfo.email }}</span>
                </li>
                <li>
                    <span>Name: {{ userInfo.name || userInfo.displayName }}</span>
                </li>
            </ul>
        </div>
        <iu-button @click="signout">sign out</iu-button>
    </div>
</template>

<script>
import firebasePlugin from '@/plugins/firebase';

export default {
    methods: {
        signout() {
            firebasePlugin.signout();
            this.showUserMenu = false;
            this.$router
                .push({
                    name: 'Signin',
                })
                // eslint-disable-next-line no-unused-vars
                .catch(err => {
                    // console.error(err);
                });
        },
    },
    computed: {
        userInfo() {
            return this.$store.state.user;
        },
    },
};
</script>

<style lang="scss" scope>
.profile-wrapper {
    padding: 20px;

    .profile {
        li {
            margin: 20px;
        }
    }
}
</style>
